import tablesConfig from '../constants/tablesConfig';

/**
 * Generates dynamic labels for the DatePicker and "Show All" button
 * in the `DataVisualizationContainer` component, based on `tablesConfig`.
 *
 * Labels are determined by the `labelType` field:
 * - 'cycles' returns labels for cycles (e.g., "Cycle Start Date").
 * - Defaults to session labels if `labelType` is not 'cycles'.
 *
 * @returns {Object} An object mapping table titles to their respective labels.
 */
export const generateLabelsByTitle = () => {
  return Object.values(tablesConfig).reduce((labels, config) => {
    const { title, labelType } = config;

    labels[title] = {
      startDateLabel: labelType === 'cycles' ? 'Cycle Start Date' : 'Session Start Date',
      showAllLabel: labelType === 'cycles' ? 'Show All Cycles' : 'Show All Sessions',
    };

    return labels;
  }, {});
};
